// 登录相关API
import request from '@/utils/request'

/**
 * 密码登录
 * @param {Object} data - 登录数据
 * @param {string} data.mobile - 手机号（账号）
 * @param {string} data.password - 密码
 * @returns {Promise}
 */
export function login(data) {
  return request({
    url: '/5c78dbfd977cf',
    method: 'post',
    data
  })
}

/**
 * 验证码登录
 * @param {Object} data - 登录数据
 * @param {string} data.phone - 手机号
 * @param {string} data.code - 验证码
 * @returns {Promise}
 */
export function loginByCode(data) {
  return request({
    url: '/5c78dca45ebc1',
    method: 'post',
    data
  })
}

/**
 * 发送验证码前安全校验
 * @param {Object} data - 校验数据
 * @param {string} data.phone - 手机号
 * @param {string} data.captcha - 验证码（图形验证码等）
 * @param {string} data.captchaToken - 验证码token（可选）
 * @returns {Promise}
 */
export function verifySecurity(data) {
  return request({
    url: '/6668f5d1d434e',
    method: 'post',
    data
  })
}

/**
 * 发送验证码
 * @param {string} phone - 手机号
 * @returns {Promise}
 */
export function sendCode(data) {
  return request({
    url: '/5b5bdc44796e8',
    method: 'post',
    data
  })
}

/**
 * 验证验证码（用于找回密码/身份校验）
 * @param {Object} data - 数据
 * @param {string} data.phone - 手机号
 * @param {string} data.code - 验证码
 * @returns {Promise}
 */
export function verifyCodeForPassword(data) {
  return request({
    url: '/5f6db4db8abcf',
    method: 'post',
    data
  })
}

/**
 * 重置密码
 * @param {Object} data - 数据
 * @param {string} data.phone - 手机号
 * @param {string} data.code - 验证码
 * @param {string} data.newPassword - 新密码
 * @returns {Promise}
 */
export function resetPassword(data) {
  return request({
    url: '/5caeeba9866aa',
    method: 'post',
    data
  })
}


